// extracted by mini-css-extract-plugin
export default {"contact-link":"cdKZ"};